import React, { Component } from 'react';
import './PublicDialog.css';

export function PublicDialogButton({ name, text, className = '', minWidth, disabled = false, onClick }) {
  return (
    <button type="button" name={name} className={'btnAction ' + className}
      style={{ minWidth }} disabled={disabled} onClick={onClick}>
      {text}
    </button>
  );
}

// Shared shell for contact, sign-up, the contract chooser and the security notice.
// The underlying transaction dialogs retain their existing wallet behavior.
class PublicDialog extends Component {
  componentDidMount() {
    this.previousFocus = document.activeElement;
    this.previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.panel.focus();
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = this.previousOverflow;
    if (this.previousFocus && document.documentElement.contains(this.previousFocus)) {
      this.previousFocus.focus({ preventScroll: true });
    }
  }

  handleKeyDown = event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.props.onClose(event);
    }
    if (event.key !== 'Tab') return;

    const controls = Array.from(this.panel.querySelectorAll(
      'a[href], button:not(:disabled), input:not(:disabled), textarea:not(:disabled), [tabindex="0"]'
    )).filter(node => node.getClientRects().length > 0 && !node.classList.contains('disabled'));
    const first = controls[0];
    const last = controls[controls.length - 1];
    const focused = document.activeElement;
    if (!first) {
      event.preventDefault();
      this.panel.focus();
    } else if (event.shiftKey && (focused === first || focused === this.panel || !this.panel.contains(focused))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (focused === last || focused === this.panel || !this.panel.contains(focused))) {
      event.preventDefault();
      first.focus();
    }
  };

  render() {
    return (
      <div className="publicDialogBackdrop" onMouseDown={event => {
        if (event.target === event.currentTarget) this.props.onClose(event);
      }}>
        <section className="publicDialogPanel" role="dialog" aria-modal="true"
          aria-labelledby="public-dialog-title" tabIndex={-1} ref={node => this.panel = node}>
          <button type="button" className="publicDialogClose" aria-label="Close" onClick={this.props.onClose}>
            <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">
              <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" strokeWidth="1.8" />
            </svg>
          </button>
          {this.props.children}
        </section>
      </div>
    );
  }
}

export default PublicDialog;
